// extracted by mini-css-extract-plugin
export default {"container":"RichTextEditorDemo_container__vto2u"};